<template>
  <div>
    <router-view/>
    <!-- <div
      v-viewer="options"
      class="images clearfix">
      <template v-for="{source, thumbnail} in images">
        <img
          :key="source"
          :src="thumbnail"
          :data-source="source"
          :alt="source"
          class="image"
        >
      </template>
    </div> -->
    <EventBus
      @onViewImages="onViewImages"
    />

    <div
      v-viewer="options"
      class="images ">
      <template v-for="{source, thumbnail} in images">
        <img
          :key="source"
          :src="thumbnail"
          :data-source="source"
          :alt="source"
          class="image"
        >
      </template>
    </div>
  </div>
</template>

<style>
  #nprogress .bar {
    background: #FF9800;
    height: 3px;
  }
  #nprogress .spinner-icon {
    border-top-color: #FF9800;
    border-left-color: #FF9800;
  }
</style>

<script>
import { upyun } from './filters'
export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      options: {
        toolbar: true,
        url: 'data-source',
        initialViewIndex: 0,
      },
      images: {},
    }
  },
  methods: {
    async onViewImages (obj) {
      let images
      if (Array.isArray(obj)) {
        images = obj
      } else {
        images = obj.images
      }
      this.images = images.map(item => {
        return {
          thumbnail: upyun(item, '!/fh/68'),
          source: upyun(item),
        }
      })
      await this.$nextTick()
      setTimeout(() => {
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.view(obj.index || 0)
      }, 100) // 插件BUG，不加 settimeout 不显示
    }
  }
}
</script>
<style lang="postcss" scoped>
.images {
  transform: translate(-10000vh,-10000vh);
}
</style>



// WEBPACK FOOTER //
// src/App.vue